import { getArray } from "../utils";

export const STATE_ALL = "0";
export const STATE_ACTIVE = "1";
export const STATE_WRITTEN_OFF = "2";

export const STATUS_FREE = "0";
export const STATUS_ISSUED = "1";
export const STATUS_WRITTEN_OFF = "2";

export const WITHOUT_EXPIRATION = "without-expiration";
export const WITH_EXPIRATION = "with-expiration";
export const EXPIRED = "expired";
export const EXPIRATION_PERIOD = "expiration-period";
export const EXPIRATION_DAYS = "expiration-days";

export function FiltersModel() {
    const fields = {
        state: STATE_ALL,
        categories: [],
        subcategories: [],
        types: [],
        categoriesExclude: false,

        nameAndNumber: "",
        workers: [],
        status: null,
        expiration: null,
        expirationDays: "",

        expirationFrom: "",
        expirationTo: "",
        expirationRange: "",
    };

    async function init(query) {
        if (query.state === STATE_ACTIVE) fields.state = STATE_ACTIVE;
        else if (query.state === STATE_WRITTEN_OFF) fields.state = STATE_WRITTEN_OFF;
        else fields.state = STATE_ALL;

        fields.categories = getArray(query.categories);
        fields.subcategories = getArray(query.subcategories);
        fields.types = getArray(query.types);

        fields.categoriesExclude = query.categories_exclude === "1";

        fields.nameAndNumber = query.nameAndNumber || "";
        fields.workers = getArray(query.workers);
        fields.status = query.status || null;

        fields.expiration = query.expiration || null;

        if (query.expiration === EXPIRATION_DAYS) {
            fields.expirationDays = parseInt(query.expiration_days, 10) || "";
        } else if (query.expiration === EXPIRATION_PERIOD) {
            fields.expirationFrom = query.expiration_from;
            fields.expirationTo = query.expiration_to;
        }
    }

    function update(filters) {
        Object.keys(fields).forEach((key) => {
            fields[key] = filters[key];
        });
    }

    function getParams() {
        const {
            state,
            categories,
            subcategories,
            types,
            categoriesExclude,
            nameAndNumber,
            workers,
            status,
            expiration,
            expirationDays,
            expirationFrom,
            expirationTo,
        } = fields;

        const params = {};

        if (state === STATE_ACTIVE) {
            params.active = 1;
        } else if (state === STATE_WRITTEN_OFF) {
            params.decommissioned = 1;
        }

        if (nameAndNumber) params.name_has = nameAndNumber;
        if (workers.length) params.worker = workers;
        if (status) params.status = status;

        if (categories.length) params["global[category]"] = categories;
        if (subcategories.length) params["global[subcategory]"] = subcategories;
        if (types.length) params["global[type]"] = types;

        if (categoriesExclude) params["global[exclude]"] = 1;

        if (expiration === WITHOUT_EXPIRATION) {
            params.not_expiry = 1;
        } else if (expiration === WITH_EXPIRATION) {
            params.has_expiry = 1;
        } else if (expiration === EXPIRED) {
            params.expired = 1;
        } else if (expiration === EXPIRATION_DAYS) {
            if (expirationDays) {
                params.interval_days = expirationDays;
            }
        } else if (expiration === EXPIRATION_PERIOD) {
            params.interval_from = expirationFrom;
            params.interval_to = expirationTo;
        }

        return params;
    }

    function getUrlParams() {
        const {
            state,
            categories,
            subcategories,
            types,
            categoriesExclude,
            nameAndNumber,
            workers,
            status,
            expiration,
            expirationDays,
            expirationFrom,
            expirationTo,
        } = fields;

        const params = {};

        params.state = state;

        if (nameAndNumber) params.nameAndNumber = nameAndNumber;
        if (workers.length) params.workers = workers.join(",");
        if (status) params.status = status;

        if (categories.length) params.categories = categories.join(",");
        if (subcategories.length) params.subcategories = subcategories.join(",");
        if (types.length) params.types = types.join(",");

        if (categoriesExclude) params.categories_exclude = 1;

        if (expiration) params.expiration = expiration;
        if (expirationDays) params.expiration_days = expirationDays;
        if (expirationFrom) params.expiration_from = expirationFrom;
        if (expirationTo) params.expiration_to = expirationTo;

        return params;
    }

    return {
        fields,
        init,
        update,
        getParams,
        getUrlParams,
    };
}
